/// <reference path="types/MicrosoftMaps/Microsoft.Maps.All.d.ts"/>